(function () {
  var query = '(max-width: 760px)';

  function setupCarousel(carousel) {
    if (!carousel || carousel.dataset.v11MobileCarousel === '1') return;
    var track = carousel.querySelector('#ba-track');
    var prev = carousel.querySelector('#ba-prev');
    var next = carousel.querySelector('#ba-next');
    var current = carousel.querySelector('#ba-current');
    var dots = carousel.querySelector('#ba-dots');
    if (!track || !prev || !next) return;

    carousel.dataset.v11MobileCarousel = '1';

    function slides() {
      return Array.prototype.slice.call(track.querySelectorAll('.carousel__slide'));
    }

    function isMobile() {
      return window.matchMedia(query).matches;
    }

    function activeIndex() {
      var items = slides();
      if (!items.length) return 0;
      var left = track.scrollLeft;
      var best = 0;
      var bestDistance = Infinity;
      items.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - track.offsetLeft - left);
        if (distance < bestDistance) {
          best = index;
          bestDistance = distance;
        }
      });
      return best;
    }

    function updateUi(index) {
      var items = slides();
      if (!items.length) return;
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      prev.disabled = index <= 0;
      next.disabled = index >= items.length - 1;
      if (dots) {
        Array.prototype.slice.call(dots.children).forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }
    }

    function goTo(index) {
      var items = slides();
      if (!items.length) return;
      var nextIndex = Math.max(0, Math.min(items.length - 1, index));
      track.scrollTo({ left: items[nextIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      updateUi(nextIndex);
    }

    prev.addEventListener('click', function (event) {
      if (!isMobile()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      goTo(activeIndex() - 1);
    }, true);

    next.addEventListener('click', function (event) {
      if (!isMobile()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      goTo(activeIndex() + 1);
    }, true);

    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      window.requestAnimationFrame(function () { updateUi(activeIndex()); });
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (!isMobile()) return;
      track.style.transform = 'none';
      goTo(activeIndex());
    }, { passive: true });

    if (isMobile()) {
      track.style.transform = 'none';
      updateUi(activeIndex());
    }
  }

  function setupAll() {
    document.querySelectorAll('#ba-carousel').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', setupAll);
})();
